import { Flex } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

export default function FullScreenLayout() {
  return (
    <Flex w="100vw" h="100vh">
      <Outlet />
    </Flex>
  );
}
